module.exports = __webpack_public_path__ + "img/appLogo@2x.5660da47.png";